import { InfiniteData } from "@tanstack/react-query";

export function extractInfoFromInfiniteData<T>(
  data: InfiniteData<T> | undefined,
): T[] {
  if (!data) return [];

  return data.pages.flatMap((page) => page);
}

interface List<T> {
  records: T[];
}

export function extractListRecords<T>(lists: List<T>[]): T[] {
  if (!lists) return [];
  return lists.flatMap((v) => v.records);
}

type Key = string | number | symbol;

export function extractPropertyFromListRecords<
  R extends {
    [key: Key]: any;
  },
  T = any,
>(records: R[] | Record<Key, T>[], propertyKey: Key): T[] {
  return records.flatMap((record) => record[propertyKey]);
}
